import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexView from '@/views/index.vue'


Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexView,
    children: [
      {
        path: '/',
        component: () => import('@/views/home.vue')
      },
      {
        path: '/myCourses',
        component: () => import('@/components/myCourses.vue')
      },
      {
        path: '/courseDetails',
        component: () => import('@/components/courseDetails.vue')
      },
      {
        path: '/pay',
        component: () => import('@/components/pay.vue')
      },
      {
        path: '/course',
        component: () => import('@/views/course.vue')
      },
      {
        path: '/orderForm',
        component: () => import('@/views/orderForm.vue')
      }
    ]
  }
]


const router = new VueRouter({
  routes,
  
})

export default router